var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"mb-2 position-sticky top-10 z-index-5",attrs:{"show":_vm.successCountDown,"variant":_vm.variant},on:{"dismissed":_vm.hideNotification}},[_c('i',{staticClass:"fa fa-check-circle mr-2"}),_c('span',{staticClass:"sub-title mr-2"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }